export const MODIFICA_EMAIL             = 'modifica_email';
export const MODIFICA_SENHA             = 'modifica_senha';
export const MODIFICA_NOME              = 'modifica_nome';
export const MODIFICA_LOGIN              = 'MODIFICA_LOGIN';
export const CADASTRO_USUARIO_SUCESSO   = 'cadastro_usuario_sucesso';
export const MODIFICA_ADICIONA_CONTATO_EMAIL = 'modifica_adiciona_contato_email';
export const ADICIONA_CONTATO_ERRO      = 'adiciona_contato_erro';
export const ADICIONA_CONTATO_SUCESSO   = 'adiciona_contato_sucesso';
export const LISTA_CONTATO_USUARIO      = 'lista_contato_usuario';
export const MODIFICA_MENSAGEM          = 'modifica_mensagem';
export const LISTA_CONVERSA_USUARIO     = 'lista_conversa_usuario';
export const ENVIA_MENSAGEM_SUCESSO     = 'envia_mensagem_sucesso';
export const LISTA_CONVERSAS_USUARIO     = 'lista_conversas_usuario';
export const LOGIN_USUARIO_SUCESSO      = 'login_usuario_sucesso';
// export const LOGIN_USUARIO_ERRO         = 'login_usuario_erro';
// export const LOGIN_EM_ANDAMENTO         = 'login_em_andamento';
// export const CADASTRO_USUARIO_ERRO      = 'cadastro_usuario_erro';
// export const CADASTRO_EM_ANDAMENTO      = 'cadastro_em_andamento';
export const LOGOUT     = 'LOGOUT';
export const ATUALIZA_AGENTES     = 'ATUALIZA_AGENTES';
export const VERIFICAR_AGENTE_CONECTADO     = 'VERIFICAR_AGENTE_CONECTADO';
export const EXTENSION_AVAILABLE     = 'EXTENSION_AVAILABLE';
export const LOADING     = 'LOADING';

// export const VERIFICAR_AGENTE_FILAS     = 'VERIFICAR_AGENTE_FILAS';

//QueuesReducer 
export const UPDATE_WAITING         = 'UPDATE_WAITING';
export const REMOVE_WAITING         = 'REMOVE_WAITING';
export const SET_QUEUES_TO_LISTEN   = 'SET_QUEUES_TO_LISTEN';
export const RESET_QUEUES_WAITING   = 'RESET_QUEUES_WAITING';
export const UPDATE_ABANDON         = 'UPDATE_ABANDON';

export const UPDATE_CONNECTED       = 'UPDATE_CONNECTED';
export const REMOVE_CONNECTED       = 'REMOVE_CONNECTED';
export const UPDATE_COMPLETED       = 'UPDATE_COMPLETED';

export const CONNECTION_SERVER       = 'CONNECTION_SERVER';
